import {styled} from "@mui/material/styles"
import {Button} from "@mui/material"

const Cashmere25MenuButton = styled(Button)`
    width: 100%;
    height: 3.5rem;
    padding: 0;
    background: none;
    background-color: transparent;
    color: ${({theme}) => theme.colours.palette.text.primary};
    font-size: ${({theme}) => theme.colours.typography.body3.fontSize};
    font-family: ${({theme}) => `${theme.colours.component.buttonLarge.fontFamily}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.component.buttonLarge.fontWeight};
    letter-spacing: ${({theme}) => theme.colours.component.buttonLarge.letterSpacing};
    line-height: ${({theme}) => theme.colours.component.buttonLarge.lineHeight};
    text-transform: ${({theme}) => theme.colours.typography.overline.textTransform};
    &:hover {
        background-color: transparent;
    }
    &&:focus {
        border: none;
    }
    .plp-menu-button-text {
        letter-spacing: 0.0625rem;
    }
`

export const StyledMenuIcon = styled("img")`
    color: ${({theme}) => theme.colours.text.default};
    height: 1.5rem;
    margin-right: 0.5rem;
`

export default Cashmere25MenuButton
